import React from 'react';
import { ITooltipProps, Text, TooltipHost, Stack, Icon } from '@fluentui/react';
import { StyledTag } from './StyledTag';

export interface StyledMultiTagProps {
  tags: string[];
}

const cseaiLabel = 'CSEAI';

function sortLabelsList(labelsList: string[]): string[] {
  labelsList.sort();

  const cseaiIndex = labelsList.indexOf(cseaiLabel);

  // If CSEAI label exists in list and isn't at the front then shift it to front of list
  if (cseaiIndex > 0) {
    labelsList.splice(cseaiIndex, 1);
    labelsList.unshift(cseaiLabel);
  }

  return labelsList;
}

export const StyledMultiTag: React.FunctionComponent<StyledMultiTagProps> = props => {
  const sortedLabelsList = sortLabelsList(props.tags);

  // Applying styling and traits to tooltip
  const renderTooltip = (): JSX.Element => {
    if (sortedLabelsList.length > 1) {
      const [, ...tooltipTraits] = sortedLabelsList;
      const additionalLabels = tooltipTraits.reduce((prev, cur, index) => (index === 0 ? cur : `${prev}, ${cur}`), '');
      return <>{additionalLabels}</>;
    }
    return <></>;
  };
  const tooltipProps: ITooltipProps = {
    onRenderContent: renderTooltip,
    style: {
      maxHeight: '500px'
    }
  };

  // The total of labels that will be displayed by tooltip
  const otherLabelsTotal = sortedLabelsList.length - 1;

  return (
    <>
      <Text className="ms-fontColor-white text-center" variant="smallPlus">
        {sortedLabelsList.length > 1 ? (
          <Stack horizontal>
            <StyledTag tag={sortedLabelsList[0]} />
            <TooltipHost closeDelay={500} tooltipProps={tooltipProps}>
              <StyledTag>
                {otherLabelsTotal} <Icon iconName="Tag" />
              </StyledTag>
            </TooltipHost>
          </Stack>
        ) : (
          <StyledTag tag={sortedLabelsList[0]} />
        )}
      </Text>
    </>
  );
};

export default StyledMultiTag;
